<script setup lang="ts">
import { computed, onMounted, onUnmounted, ref } from 'vue';

import { getStoredItemsCount } from '@/services/booking/cartsTransactionsApi.ts';

const cartItemCount = ref(getStoredItemsCount());
const hasItems = computed(() => cartItemCount.value !== null && cartItemCount.value > 0);

function handleCartMessage(event: MessageEvent) {
  if (event.data?.event_id === 'cart_update' && event.data?.provider === 'youbook') {
    cartItemCount.value = Number.parseInt(event.data.items_count ?? '0', 10);
  }
}

onMounted(() => {
  window.addEventListener('message', handleCartMessage);
});

onUnmounted(() => {
  window.removeEventListener('message', handleCartMessage);
});

function openCartDetails(link: string) {
  window.open(link, '_blank');
}
</script>

<template>
  <div class="cart-container yb-preset" @click="openCartDetails('/panier-v2.html')">
    <div class="cart-icon">
      <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <path
          d="M0.75 0.75H2.08333L3.85667 9.03C3.92172 9.33324 4.09045 9.60432 4.33381 9.79657C4.57717 9.98883 4.87994 10.0902 5.19 10.0833H11.71C12.0135 10.0828 12.3077 9.97886 12.544 9.78856C12.7804 9.59826 12.9448 9.33302 13.01 9.03667L14.11 4.08333H2.79667M5.38346 13.3833C5.38346 13.7515 5.08499 14.05 4.7168 14.05C4.34861 14.05 4.05013 13.7515 4.05013 13.3833C4.05013 13.0151 4.34861 12.7166 4.7168 12.7166C5.08499 12.7166 5.38346 13.0151 5.38346 13.3833ZM12.7168 13.3833C12.7168 13.7515 12.4183 14.05 12.0501 14.05C11.6819 14.05 11.3835 13.7515 11.3835 13.3833C11.3835 13.0151 11.6819 12.7166 12.0501 12.7166C12.4183 12.7166 12.7168 13.0151 12.7168 13.3833Z"
          stroke="black" stroke-width="1.5"
          stroke-linecap="round" stroke-linejoin="round"
        />
      </svg>
      <span v-if="hasItems" class="cart-count">
        {{ cartItemCount }}
      </span>
    </div>
  </div>
</template>

<style scoped lang="css">
.cart-container {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  position: relative;
  cursor: pointer;
}

.cart-icon {
  width: 30px;
  height: 30px;

  span {
    display: flex;
    width: 17px;
    height: 17px;
    background: var(--yb-color-primary);
    justify-content: center;
    align-items: center;
    color: var(--yb-color-white);
    border-radius: var(--yb-radius-semi);
    position: absolute;
    top: -15%;
    right: 10%;
    font-weight: var(--yb-text-bold);
    font-size: 11px;
    line-height: 0;
  }
}
</style>
